import firebase from 'firebase/app';
import { database } from './config';
import ErrorLog from './error';
const Error = new ErrorLog()

export default class Usuario {
    constructor() {
        this.Activo = true
        this.Nombre = ''
        this.Apellido = ''
        this.Email = ''
        this.Direccion = ''
        this.userLogged = null

        firebase.auth().onAuthStateChanged(user => {
            this.userLogged = user
        })
    }

    

    getUserLogged() {
        const _this = this
        return new Promise((resolve, reject) => {
            const unsubscribe = firebase.auth().onAuthStateChanged(user => {
                unsubscribe()
                _this.userLogged = user
                resolve(user)
            }, reject)
        })
    }

    isUserAdmin(user) {
        return new Promise((resolve, reject) => {
            if (!user) resolve(false)

            let docRef = database.collection("usuarios").doc(user.uid)
            docRef.get()
                .then(doc => {
                    !doc.exists && resolve(false)
                    resolve(doc.data().IsAdmin)
                })
                .catch(error => Error.guardarError(error))
        })
    }

    getUsers() {
        return new Promise((resolve, reject) => {
            database.collection("usuarios")
                .get()
                .then(querySnapshot => resolve(querySnapshot.docs))
                .catch(error => reject(Error.guardarError(error)))
        })
    }

    leerUsuario(uid) {
        return new Promise((resolve, reject) => {
            database.collection("usuarios")
                .doc(uid)
                .get()
                .then(doc => resolve(doc.data()))
                .catch(error => reject(Error.guardarError(error)))
        })
    }

    

    guardarUsuario(user) {
        return new Promise((resolve, reject) => {
            database.collection("usuarios")
                .doc(user.uid)
                .set(user, {merge: true})
                .then(result => resolve(result))
                .catch(error => reject(Error.guardarError(error)))
        })
    }

    

}